import { ReactNode } from 'react';

import env from '../../feature-flags.json';
import dev from '../../feature-flags.dev.json';

export type FeatureFlag = keyof typeof env;

// @ts-expect-error The variable is injected by webpack.DefinePlugin.
const flags = { ...env, ...( HPP_ENV === 'production' ? {} : dev ) };

export default function feature( flag: FeatureFlag ) {
	return flags[ flag ] || false;
}

interface Props {
	flag: FeatureFlag;
	flip?: boolean;
	children: ReactNode;
}

export function FeatureGate( { flag, children, flip = false }: Props ) {
	if ( feature( flag ) === flip ) {
		return null;
	}

	return children;
}
